/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Box_Label_Package_CountInputs */

const vi_box_label_package_count = /** @type {(inputs: Box_Label_Package_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số kiện`)
};

/**

* @param {Box_Label_Package_CountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const box_label_package_count = /** @type {((inputs?: Box_Label_Package_CountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Box_Label_Package_CountInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_box_label_package_count(inputs)
});